{
    "common": {
        "loading": "Carregando…",
        "retry": "Tentar novamente",
        "cancel": "Cancelar",
        "save": "Salvar",
        "delete": "Excluir",
        "edit": "Editar",
        "close": "Fechar",
        "closeSidebar": "Fechar barra lateral",
        "open": "Abrir",
        "activeServerAriaLabel": "Servidor ativo: {{name}}. Clique para trocar.",
        "viewAll": "Ver tudo",
        "selectServer": "Selecione um servidor",
        "accessDenied": "Acesso negado",
        "accessDeniedDescription": "Você não tem permissão para visualizar o módulo {{module}} deste servidor.",
        "logout": "Sair",
        "language": "Idioma",
        "name": "Nome",
        "error": "Erro",
        "color": "Cor",
        "selectServerDesc": "Selecione um servidor para continuar"
    },
    "linkResult": {
        "spotifyLinked": "Conta do Spotify vinculada com sucesso.",
        "lastfmLinked": "Conta do Last.fm vinculada com sucesso.",
        "errors": {
            "generic": "Não foi possível vincular sua conta. Tente novamente.",
            "spotify_connect_error": "Não foi possível iniciar a conexão com o Spotify. Tente novamente.",
            "spotify_exchange_failed": "Não foi possível concluir a autorização do Spotify. Tente novamente.",
            "spotify_invalid_state": "O pedido de vinculação do Spotify expirou ou era inválido. Tente novamente.",
            "spotify_missing_code": "O Spotify não retornou um código de autorização. Tente novamente.",
            "spotify_missing_state": "O pedido de vinculação do Spotify estava incompleto. Tente novamente.",
            "spotify_not_configured": "A vinculação com o Spotify não está configurada neste servidor.",
            "spotify_save_failed": "O Spotify foi autorizado, mas não conseguimos salvar a vinculação. Tente novamente.",
            "lastfm_callback_error": "O Last.fm retornou um erro ao vincular. Tente novamente.",
            "lastfm_connect_error": "Não foi possível iniciar a conexão com o Last.fm. Tente novamente.",
            "lastfm_exchange_failed": "Não foi possível concluir a autorização do Last.fm. Tente novamente.",
            "lastfm_invalid_state": "O pedido de vinculação do Last.fm expirou ou era inválido. Tente novamente.",
            "lastfm_missing_state": "O pedido de vinculação do Last.fm estava incompleto. Tente novamente.",
            "lastfm_missing_token": "O Last.fm não retornou um token de autorização. Tente novamente.",
            "lastfm_not_configured": "A vinculação com o Last.fm não está configurada neste servidor.",
            "lastfm_save_failed": "O Last.fm foi autorizado, mas não conseguimos salvar a vinculação. Tente novamente."
        }
    },
    "languages": {
        "en": "English",
        "pt-BR": "Português (Brasil)"
    },
    "modules": {
        "overview": "visão geral",
        "settings": "configurações",
        "moderation": "moderação",
        "automation": "automação",
        "music": "música",
        "integrations": "integrações"
    },
    "notFound": {
        "title": "Página não encontrada",
        "description": "A página que você procura não existe ou foi movida.",
        "backHome": "Voltar ao início"
    },
    "sidebar": {
        "activeGuild": "Servidor ativo",
        "switchServer": "Trocar servidor",
        "commandCenter": "Central de comando",
        "status": {
            "selectServer": "Selecione um servidor",
            "needsSetup": "Precisa configurar",
            "ready": "Pronto"
        },
        "subtitle": {
            "selectServer": "Escolha uma comunidade para desbloquear as ferramentas do servidor.",
            "needsSetup": "O Lucky ainda não está instalado neste servidor.",
            "ready": "A central de comando do servidor está pronta para operar."
        },
        "sections": {
            "overview": "Visão geral",
            "moderation": "Moderação",
            "automation": "Automação",
            "community": "Comunidade",
            "media": "Mídia",
            "integrations": "Integrações"
        },
        "nav": {
            "dashboard": "Painel",
            "serverSettings": "Configurações do servidor",
            "modCases": "Casos de moderação",
            "autoModeration": "Auto-moderação",
            "serverLogs": "Logs do servidor",
            "autoMessages": "Mensagens automáticas",
            "embedBuilder": "Construtor de embeds",
            "reactionRoles": "Cargos por reação",
            "guildAutomation": "Automação do servidor",
            "levelSystem": "Sistema de níveis",
            "musicPlayer": "Player de música",
            "trackHistory": "Histórico de faixas",
            "lyrics": "Letras",
            "musicalTaste": "Gosto musical",
            "lastFm": "Last.fm",
            "twitch": "Twitch",
            "features": "Recursos",
            "config": "Configuração",
            "batchJobs": "Tarefas em lote",
            "supportReports": "Relatórios de suporte",
            "roles": "Funções",
            "roleGroups": "Grupos de cargos"
        }
    },
    "layout": {
        "routes": {
            "dashboard": {
                "title": "Painel",
                "subtitle": "Visão operacional e principais indicadores do seu servidor."
            },
            "servers": {
                "title": "Servidores",
                "subtitle": "Confira o status de instalação e gerencie suas comunidades elegíveis."
            },
            "serverSettings": {
                "title": "Configurações do servidor",
                "subtitle": "Configure o comportamento do bot, canais, cargos e preferências."
            },
            "moderation": {
                "title": "Casos de moderação",
                "subtitle": "Revise e gerencie ações de moderação deste servidor."
            },
            "autoMod": {
                "title": "Auto-moderação",
                "subtitle": "Configure regras automáticas e filtros de aplicação."
            },
            "serverLogs": {
                "title": "Logs do servidor",
                "subtitle": "Inspecione eventos de auditoria e atividades do bot."
            },
            "autoMessages": {
                "title": "Mensagens automáticas",
                "subtitle": "Agende mensagens recorrentes em qualquer canal."
            },
            "embedBuilder": {
                "title": "Construtor de embeds",
                "subtitle": "Crie e envie embeds avançados do Discord."
            },
            "reactionRoles": {
                "title": "Cargos por reação",
                "subtitle": "Atribua cargos com base nas reações de emoji dos membros."
            },
            "guildAutomation": {
                "roles": {
                    "title": "Cargos",
                    "subtitle": "Gerencie os cargos do Discord do seu servidor"
                },
                "title": "Automação do servidor",
                "subtitle": "Configure fluxos automatizados de gerenciamento do servidor."
            },
            "levels": {
                "title": "Sistema de níveis",
                "subtitle": "Configure XP, cargos por nível e rankings."
            },
            "lyrics": {
                "title": "Letras",
                "subtitle": "Busque e exiba letras de músicas no seu servidor."
            },
            "lastFm": {
                "title": "Last.fm",
                "subtitle": "Controle a vinculação de contas e a atribuição de scrobbles."
            },
            "twitch": {
                "title": "Notificações da Twitch",
                "subtitle": "Envie alertas ao vivo quando streamers monitorados ficam online."
            },
            "features": {
                "title": "Recursos",
                "subtitle": "Ative ou desative módulos de recursos para o seu servidor."
            },
            "trackHistory": {
                "title": "Histórico de faixas",
                "subtitle": "Inspecione a reprodução recente e a atividade dos solicitantes."
            },
            "music": {
                "title": "Player de música",
                "subtitle": "Gerencie fila, autoplay e controles de reprodução em tempo real."
            },
            "preferredArtists": {
                "title": "Gosto musical",
                "subtitle": "Ajuste preferências de autoplay e prioridade de artistas."
            },
            "spotify": {
                "title": "Spotify",
                "subtitle": "Vincule ou desvincule o Spotify para alimentar o autoplay."
            },
            "fallback": {
                "title": "Painel Lucky",
                "subtitle": "Configure módulos, moderação e fluxos de engajamento."
            },
            "roleGroups": {
                "title": "Grupos de cargos",
                "subtitle": "Crie e gerencie coleções de cargos estilizados."
            }
        }
    },
    "landing": {
        "meta": {
            "title": "Lucky: bot de música grátis do Discord com autoplay e painel",
            "description": "Lucky aprende o gosto musical do seu servidor e mantém a call tocando, sem precisar de DJ. Grátis, sem paywall."
        },
        "hero": {
            "eyebrow": "Open source · ISC",
            "headlineLine1": "Aprende o gosto do seu servidor.",
            "headlineLine2": "Mantém a call tocando.",
            "subtitle": "Sem precisar de DJ. Busque pelo nome ou cole um link do Spotify, e o autoplay continua a partir daí. Grátis, sem paywall.",
            "ctaPrimary": "Adicionar ao Discord"
        },
        "repoCard": {
            "name": "LucasSantana-Dev / Lucky",
            "description": "Bot de música do Discord com autoplay que aprende o gosto do servidor e painel React.",
            "license": "ISC",
            "lang": "TypeScript",
            "serversLabel": "servidores",
            "usersLabel": "usuários",
            "viewOnGithub": "Ver no GitHub",
            "copyClone": "Copiar URL de clone"
        },
        "commands": {
            "heading": "Comandos de música, onde você precisa deles",
            "rows": {
                "play": {
                    "name": "/play",
                    "description": "Adicione uma música pelo nome ou cole um link do Spotify",
                    "kbd": "música"
                },
                "autoplay": {
                    "name": "/autoplay",
                    "description": "Recomendações por gênero, sem trocar de idioma",
                    "kbd": "música"
                },
                "queue": {
                    "name": "/queue",
                    "description": "Veja ou reordene a fila atual",
                    "kbd": "música"
                },
                "skip": {
                    "name": "/skip",
                    "description": "Pule a música atual",
                    "kbd": "música"
                },
                "lyrics": {
                    "name": "/lyrics",
                    "description": "Veja a letra da música atual",
                    "kbd": "música"
                },
                "recap": {
                    "name": "/recap",
                    "description": "Resumo semanal do que o servidor ouviu",
                    "kbd": "música"
                }
            },
            "more": "+ mais comandos com /help"
        },
        "stack": {
            "heading": "Para desenvolvedores — o que você está rodando",
            "subheading": "Stack padrão Node + Postgres. Nada exótico. `docker compose up` e você está online. Pule esta seção se está usando a versão hospedada.",
            "items": {
                "bot": {
                    "name": "lucky-bot",
                    "description": "Cliente discord.js, áudio sem Lavalink via yt-dlp + Opus"
                },
                "backend": {
                    "name": "lucky-backend",
                    "description": "API Express, OAuth, Prisma com Postgres"
                },
                "frontend": {
                    "name": "lucky-frontend",
                    "description": "React 19 + Vite + Tailwind, painel com OAuth do Discord"
                },
                "postgres": {
                    "name": "postgres",
                    "description": "Config de servidor, histórico musical, estado de autoplay"
                },
                "redis": {
                    "name": "redis",
                    "description": "Cache de sessão, rate-limit, estado de autoplay"
                },
                "nginx": {
                    "name": "nginx",
                    "description": "Reverse proxy, rewrite /webhook → /hooks para deploy"
                }
            }
        },
        "footerRepo": {
            "heading": "Open source sob ISC",
            "subheading": "Fork, contribua, rode, faça o deploy. O código é a especificação."
        },
        "footer": {
            "tagline": "Bot do Discord open source. Rode você mesmo ou use a versão hospedada.",
            "links": "Produto",
            "support": "Comunidade",
            "supportCopy": "Issues e PRs são bem-vindos no GitHub. Ou entre no servidor de suporte do Discord.",
            "terms": "Termos",
            "privacy": "Privacidade",
            "github": "Código-fonte",
            "docs": "Docs",
            "changelog": "Changelog",
            "discord": "Servidor de suporte",
            "copyright": "© 2026 Lucky. ISC."
        },
        "features": {
            "heading": "O que o Lucky faz",
            "subheading": "Tudo que a maioria dos servidores precisa, em um bot só. Sem tier premium escondendo o que importa.",
            "items": {
                "music": {
                    "title": "Música com autoplay inteligente",
                    "description": "Busque pelo nome ou cole um link do Spotify. O autoplay aprende o clima e não troca de idioma."
                },
                "recap": {
                    "title": "Recap semanal automático",
                    "description": "Todo domingo, o Lucky posta um resumo do que o servidor ouviu: top músicas, total de plays e tempo de escuta."
                },
                "dashboard": {
                    "title": "Um painel web de verdade",
                    "description": "Configure tudo direto do navegador. Login com OAuth do Discord, sem arquivos JSON, sem SSH."
                }
            }
        }
    },
    "login": {
        "meta": {
            "title": "Entrar - Lucky",
            "description": "Entre no painel do Lucky para gerenciar seus servidores do Discord"
        },
        "brand": "Painel do Bot do Discord",
        "headline": "Gerencie seus servidores do Discord",
        "description": "Configure música, preferências de autoplay e configurações do bot — tudo em um só lugar.",
        "modules": "Módulos",
        "commands": "Comandos",
        "uptime": "Tempo online",
        "authentication": "Autenticação",
        "signInWithDiscord": "Entrar com Discord",
        "permissionsNote": "Suas permissões de servidor e controles do bot estão vinculados à sua conta do Discord.",
        "connecting": "Conectando...",
        "loginButton": "Entrar com Discord",
        "badges": {
            "oauthSecured": "Protegido por OAuth",
            "fastSetup": "Configuração rápida",
            "liveControls": "Controles em tempo real"
        },
        "copyright": "© 2026 Lucky. Todos os direitos reservados.",
        "loggedOut": "Sessão encerrada com sucesso",
        "logoutFailed": "Falha ao sair",
        "authenticated": "Autenticado com sucesso!",
        "verifyFailed": "Falha ao verificar a autenticação",
        "errors": {
            "auth_failed": "Falha na autenticação. Tente novamente.",
            "missing_code": "Código de autorização ausente. Tente novamente.",
            "missing_state": "Falha na validação de segurança. Tente novamente.",
            "invalid_state": "Token de segurança inválido. Tente novamente.",
            "session_failed": "Falha ao criar a sessão. Tente novamente.",
            "authentication_error": "Ocorreu um erro durante a autenticação. Tente novamente.",
            "client_id_not_configured": "O serviço de autenticação não está configurado corretamente. Entre em contato com o suporte.",
            "redirect_error": "Falha ao redirecionar para o serviço de autenticação. Tente novamente.",
            "generic": "Ocorreu um erro"
        }
    },
    "support": {
        "title": "Relatar um problema",
        "subtitle": "Conte o que aconteceu — anexe uma captura de tela se puder.",
        "referenceId": "ID de referência",
        "form": {
            "contextLabel": "O que aconteceu?",
            "contextPlaceholder": "Descreva o que você estava fazendo e o que deu errado…",
            "imageLabel": "Captura de tela (opcional)",
            "imageTypeError": "Tipo de imagem não suportado. Use PNG, JPEG ou WebP.",
            "imageSizeError": "Imagem muito grande (máx. 5 MB).",
            "submit": "Enviar relato",
            "genericError": "Falha ao enviar seu relato. Tente novamente."
        },
        "success": {
            "title": "Obrigado pelo relato",
            "body": "Recebemos e vamos analisar."
        },
        "admin": {
            "title": "Relatos de suporte",
            "subtitle": "Relatos de erro enviados por usuários.",
            "loadError": "Não foi possível carregar os relatos.",
            "emptyTitle": "Nenhum relato",
            "emptyDescription": "Nenhum relato de suporte corresponde a este filtro.",
            "selectPrompt": "Selecione um relato para ver os detalhes.",
            "hasImage": "Tem captura de tela",
            "imageAlt": "Captura de tela do relato",
            "status": {
                "all": "Todos",
                "new": "Novo",
                "triaged": "Triado",
                "promoted": "Promovido",
                "dismissed": "Descartado"
            }
        }
    },
    "roles": {
        "title": "Funções",
        "subtitle": "Gerencie as funções do Discord do seu servidor",
        "createRole": "Criar Função",
        "noRoles": "Nenhuma função encontrada",
        "noRolesDesc": "Crie sua primeira função para começar",
        "deleteConfirm": "Tem certeza de que deseja deletar esta função?",
        "deleteConfirmDesc": "Tem certeza de que deseja deletar",
        "bulkDeleteConfirm": "Deletar {{count}} funções?",
        "bulkDeleteConfirmDesc": "Isso irá deletar permanentemente",
        "managed": "Gerenciada",
        "hoist": "Destacada",
        "mentionable": "Mencionável",
        "editRole": "Editar Função",
        "duplicated": "Função duplicada",
        "deleted": "Função deletada",
        "bulkDeleted": "{{count}} funções deletadas",
        "created": "Função criada",
        "updated": "Função atualizada",
        "failedToLoad": "Falha ao carregar funções",
        "failedToCreate": "Falha ao criar função",
        "failedToUpdate": "Falha ao atualizar função",
        "failedToDelete": "Falha ao deletar função",
        "failedToDuplicate": "Falha ao duplicar função",
        "bulkDeleteFailed": "Falha ao deletar {{count}} funções",
        "selectedCount": "{{count}} funções selecionadas",
        "delete": "Deletar",
        "roles": "funções"
    },
    "admin": {
        "adminPanel": "Painel de Administrador",
        "signInWithDiscord": "Entre com Discord para acessar o painel de administrador.",
        "accessDenied": "Acesso Negado",
        "accessDeniedDesc": "Esta página é restrita aos administradores do bot.",
        "globalFeatureToggles": "Alternância Global de Recursos",
        "manageFeatureFlags": "Gerencie sinalizadores de recursos em todos os servidores",
        "serverManagement": "Gerenciamento de Servidor",
        "viewAndManageBotActivity": "Visualize e gerencie a atividade do bot em todos os servidores"
    },
    "autoMessages": {
        "title": "Mensagens Automáticas",
        "subtitle": "Agende mensagens automáticas para {{name}}",
        "editAutoMessage": "Editar Mensagem Automática",
        "newAutoMessage": "Nova Mensagem Automática",
        "type": "Tipo",
        "typeWelcome": "Boas-vindas",
        "typeLeave": "Saída",
        "typeAutoResponse": "Resposta Automática",
        "channelId": "ID do Canal",
        "channelIdPlaceholder": "ID do canal do Discord",
        "message": "Mensagem",
        "messagePlaceholder": "Conteúdo da mensagem...",
        "trigger": "Gatilho",
        "triggerPlaceholder": "Palavra ou frase que aciona esta resposta",
        "exactMatch": "Somente correspondência exata",
        "enabled": "Ativado",
        "disabled": "Desativado",
        "cancel": "Cancelar",
        "saving": "Salvando…",
        "save": "Salvar",
        "saveError": "Falha ao salvar mensagem automática",
        "deleteError": "Falha ao excluir mensagem automática",
        "noServerSelected": "Nenhum Servidor Selecionado",
        "selectServerToManage": "Selecione um servidor para gerenciar mensagens automáticas",
        "noAutoMessagesConfigured": "Nenhuma mensagem automática configurada",
        "createScheduledMessages": "Crie mensagens agendadas que são postadas automaticamente no seu servidor",
        "editAriaLabel": "Editar mensagem de {{type}}",
        "deleteAriaLabel": "Excluir mensagem de {{type}}",
        "deleteMessage": "Excluir Mensagem Automática",
        "deleteMessageConfirm": "Tem certeza de que deseja excluir esta mensagem de {{type}}? Isso não pode ser desfeito.",
        "delete": "Excluir",
        "createAutoMessage": "Criar Mensagem Automática",
        "newMessage": "Nova Mensagem"
    },
    "autoMod": {
        "title": "Auto-moderação",
        "subtitle": "Configure filtros automáticos de conteúdo para {{name}}",
        "saveChanges": "Salvar Alterações",
        "templates": "Modelos",
        "startFromCurated": "Comece com padrões selecionados de proteção contra spam.",
        "noTemplatesAvailable": "Nenhum modelo disponível no momento.",
        "contentFilters": "Filtros de Conteúdo",
        "spamDetection": "Detecção de Spam",
        "detectAndActOnSpam": "Detecte e aja sobre spam de mensagens",
        "maxMessages": "Máximo de mensagens",
        "timeWindow": "Janela de tempo (s)",
        "exemptions": "Isenções",
        "channelsAndRolesExempt": "Canais e funções isentos de filtros de auto-moderação",
        "exemptChannels": "Canais Isentos",
        "selectChannelPlaceholder": "Selecione um canal...",
        "exemptRoles": "Funções Isentas",
        "selectRolePlaceholder": "Selecione uma função...",
        "channelsUnavailable": "Canais indisponíveis, insira IDs manualmente abaixo",
        "rolesUnavailable": "Funções indisponíveis, insira IDs manualmente abaixo",
        "channelIdPlaceholder": "ID do canal...",
        "roleIdPlaceholder": "ID da função...",
        "failedToLoadSettings": "Falha ao carregar as configurações de auto-moderação. O salvamento fica desativado até as configurações carregarem.",
        "failedToLoadTemplates": "Falha ao carregar os modelos",
        "failedToLoadChannels": "Falha ao carregar os canais do Discord",
        "failedToLoadRoles": "Falha ao carregar as funções do Discord",
        "settingsSaved": "Configurações de auto-moderação salvas!",
        "failedToSave": "Falha ao salvar as configurações",
        "templateApplied": "Modelo de auto-moderação aplicado",
        "failedToApplyTemplate": "Falha ao aplicar o modelo",
        "applyTemplate": "Aplicar modelo",
        "applyTemplateAria": "Aplicar o modelo {{name}}",
        "applyingTemplateAria": "Aplicando o modelo {{name}}",
        "noServerSelected": "Nenhum Servidor Selecionado",
        "selectServerToConfigure": "Selecione um servidor para configurar a auto-moderação"
    },
    "config": {
        "configuration": "Configuração",
        "selectServerToConfigure": "Selecione um servidor para configurar",
        "server": "Servidor:",
        "availableConfigurationModules": "Módulos de Configuração Disponíveis",
        "musicModule": "Módulo de Música",
        "configureMusic": "Configure reprodução de música, gerenciamento de fila e configurações de áudio",
        "moderation": "Moderação",
        "setupAutoModeration": "Configure auto-moderação, filtros e ações de moderação",
        "back": "Voltar",
        "pageTitle": "Configuração - Lucky",
        "pageDescription": "Configure módulos e comandos para seus servidores do Discord"
    },
    "dashboard": {
        "noServerSelected": "Nenhum Servidor Selecionado",
        "selectServerFromSidebar": "Selecione um servidor na barra lateral para gerenciá-lo",
        "viewYourServers": "Ver Seus Servidores",
        "pageTitle": "Painel de Controle"
    },
    "dashboardOverview": {
        "selectAServer": "Selecionar um Servidor",
        "chooseServerFromSidebar": "Escolha um servidor na barra lateral para ver seu painel",
        "dashboardTitle": "Painel de Controle",
        "serverAnalytics": "Análise do servidor",
        "overviewOf": "Visão geral de {{name}}",
        "totalMembers": "Total de Membros",
        "activeMembersAcross": "Membros ativos em {{name}}",
        "activeCases": "Casos Ativos",
        "totalCases": "Total de Casos",
        "autoModActions": "Ações de Auto-Mod",
        "recentCases": "Casos Recentes",
        "latestModerationActions": "Últimas ações de moderação",
        "viewAll": "Ver tudo",
        "noModerationCases": "Nenhum caso de moderação ainda",
        "casesCasesWillAppear": "Os casos aparecerão aqui quando os moderadores tomarem ações",
        "quickActions": "Ações Rápidas",
        "moderationCases": "Casos de Moderação",
        "reviewWarningsMutesKicksBans": "Revise avisos, silenciamentos, chutes e banimentos.",
        "autoModeration": "Auto-Moderação",
        "tuneFiltersAntiSpamAutomation": "Ajuste filtros e automação anti-spam.",
        "serverLogs": "Logs do Servidor",
        "auditEventsAndModerationActivity": "Eventos de auditoria e atividade de moderação.",
        "musicPlayer": "Reprodutor de Música",
        "viewQueuePlaybackTrackHistory": "Veja fila, reprodução e histórico de faixas.",
        "levelsAndXP": "Níveis e XP",
        "configureXPLevelRewardsLeaderboards": "Configure XP, recompensas de nível e placares.",
        "recentMusic": "Música Recente",
        "latestTracksPlayed": "Últimas faixas tocadas",
        "lastPlayed": "Tocada por último",
        "unknownListener": "Desconhecido",
        "noTracksPlayedYet": "Nenhuma faixa tocada ainda",
        "trackHistoryWillAppearWhenMusicPlayed": "O histórico de faixas aparecerá aqui quando a música for tocada",
        "community": "Comunidade",
        "levelLeaderboard": "Placar de Níveis",
        "topMembersByXP": "Principais membros por XP",
        "noLeaderboardData": "Sem dados de placar",
        "casesByType": "Casos por Tipo"
    },
    "embedBuilder": {
        "pageTitle": "Construtor de Embeds",
        "pageDescription": "Crie e gerencie modelos de embed Discord reutilizáveis",
        "newTemplate": "Novo Modelo",
        "fields": "Campos",
        "addField": "Adicionar Campo",
        "fieldName": "Nome do campo",
        "fieldValue": "Valor do campo",
        "inline": "Em linha",
        "removeFieldAriaLabel": "Remover campo {{index}}",
        "editEmbedTemplate": "Editar Modelo de Embed",
        "newEmbedTemplate": "Novo Modelo de Embed",
        "cancel": "Cancelar",
        "saveChanges": "Salvar Alterações",
        "createTemplate": "Criar Modelo",
        "templateName": "Nome do Modelo *",
        "templateNamePlaceholder": "ex: mensagem-boas-vindas",
        "color": "Cor",
        "title": "Título",
        "titlePlaceholder": "Título do embed",
        "description": "Descrição",
        "descriptionPlaceholder": "Descrição do embed (suporta markdown)",
        "thumbnailUrl": "URL da Miniatura",
        "thumbnailAlt": "miniatura do embed",
        "imageUrl": "URL da Imagem",
        "urlPlaceholder": "https://...",
        "footer": "Rodapé",
        "footerPlaceholder": "Texto do rodapé",
        "preview": "Prévia",
        "fillFieldsToSeePreview": "Preencha os campos para ver uma prévia",
        "saving": "Salvando...",
        "noEmbedTemplates": "Nenhum modelo de embed",
        "createFirstEmbedTemplate": "Crie seu primeiro modelo de embed para usar em comandos de bot",
        "editAriaLabel": "Editar {{name}}",
        "deleteAriaLabel": "Deletar {{name}}",
        "deleteTemplate": "Deletar Modelo",
        "deleteTemplateConfirm": "Deletar \"{{name}}\"? Isto não pode ser desfeito.",
        "delete": "Deletar",
        "used": "Usado {{count}}×",
        "field": "campo",
        "fields_plural": "campos"
    },
    "guildAutomation": {
        "pageTitle": "Automação de Guild",
        "pageDescription": "Gerencie sua configuração de guild como código — planeje, aplique e rastreie mudanças.",
        "noServerSelected": "Nenhum servidor selecionado",
        "selectServerToManage": "Selecione um servidor para gerenciar Automação de Guild.",
        "loadErrorMessage": "Não foi possível carregar o status de automação ou manifesto — a API pode estar indisponível.",
        "retry": "Tentar Novamente",
        "automationStatus": "Status de Automação",
        "refreshStatusTitle": "Atualizar status",
        "plan": "Planejar",
        "recordPlan": "Registrar Plano",
        "reconcile": "Reconciliar",
        "planResult": "Resultado do Plano",
        "planRecord": "Registro do Plano",
        "manifest": "Manifesto",
        "noManifestFound": "Nenhum manifesto encontrado. Cole ou escreva um manifesto abaixo para começar.",
        "manifestPlaceholder": "{ \"guildId\": \"...\", \"version\": \"1\", \"roles\": {}, \"channels\": {} }",
        "saveManifest": "Salvar Manifesto",
        "runHistory": "Histórico de Execuções",
        "noRunsYet": "Nenhuma execução ainda",
        "runPlanOrApply": "Execute um plano ou aplique para ver resultados aqui.",
        "invalidJsonError": "JSON inválido — por favor, corrija erros de sintaxe antes de salvar.",
        "noChangesDetected": "Nenhuma alteração detectada.",
        "appliedCount_one": "{{count}} aplicada",
        "appliedCount_other": "{{count}} aplicadas",
        "failedCount_one": "{{count}} com falha",
        "failedCount_other": "{{count}} com falha",
        "manifestSaved": "Manifesto salvo com sucesso.",
        "manifestSaveFailed": "Falha ao salvar o manifesto.",
        "planGenerated": "Plano gerado.",
        "planFailed": "Falha ao gerar o plano.",
        "planRecorded": "Plano registrado. Aplique as alterações usando /guildconfig apply no Discord.",
        "planRecordFailed": "Falha ao registrar o plano.",
        "reconcileRecorded": "Reconciliação de desvios registrada. Aplique as alterações usando /guildconfig reconcile no Discord.",
        "reconcileFailed": "Falha ao registrar a reconciliação.",
        "expandManifest": "Expandir"
    },
    "lastFm": {
        "musicIdentityEyebrow": "Identidade musical",
        "pageTitle": "Last.fm",
        "pageDescription": "Faça scrobble das faixas que você toca em seu perfil Last.fm",
        "notConfigured": "Não Configurado",
        "lastFmNotConfigured": "A integração do Last.fm não está configurada. Peça ao proprietário do servidor para definir:",
        "lastFmApiKey": "LASTFM_API_KEY",
        "lastFmApiSecret": "LASTFM_API_SECRET",
        "connected": "Conectado",
        "linkedAs": "Vinculado como",
        "active": "Ativo",
        "connectionDescription": "As faixas que você solicita via bot serão scrobbladas automaticamente para seu perfil Last.fm.",
        "disconnect": "Desconectar",
        "connectYourAccount": "Conecte Sua Conta",
        "connectAccountDescription": "Vincule sua conta Last.fm para que as faixas que você toca através do bot sejam scrobbladas automaticamente para seu perfil.",
        "connectWithLastFm": "Conectar com Last.fm",
        "scrobbleCoverage": "Cobertura de scrobble",
        "scrobbleCoverageDescription": "Lucky rastreia músicas solicitadas e encaminha atividade de reprodução uma vez vinculado.",
        "privacyControl": "Controle de privacidade",
        "privacyControlDescription": "Desconecte a qualquer momento sem afetar a reprodução do servidor.",
        "howItWorks": "Como funciona",
        "step1": "Conecte sua conta Last.fm acima",
        "step2": "Toque música em um canal de voz usando o bot",
        "step3": "As faixas são automaticamente scrobbladas para seu perfil",
        "step4": "Bots de música externos (Rythm, Groovy, etc.) também são detectados",
        "failedToLoadStatus": "Falha ao carregar status do Last.fm",
        "failedToUnlink": "Falha ao desvinacular conta",
        "disconnectConfirm": "Desconectar sua conta Last.fm?"
    },
    "levels": {
        "noServerSelected": "Nenhum servidor selecionado",
        "selectServerToView": "Selecione um servidor para visualizar as configurações de nível",
        "leaderboard": "Placar de Classificação",
        "noDataYet": "Sem dados ainda",
        "membersGainXp": "Membros ganham XP conversando quando o sistema de níveis está ativado",
        "level": "Nível",
        "xp": "XP",
        "settings": "Configurações",
        "enableXp": "Ativar XP",
        "xpPerMessage": "XP Por Mensagem",
        "cooldown": "Cooldown (ms)",
        "announceChannel": "Canal de Anúncio",
        "channelIdOptional": "ID do Canal (opcional)",
        "saveSettings": "Salvar Configurações",
        "saving": "Salvando...",
        "levelRewards": "Recompensas de Nível",
        "couldNotLoadRoles": "Não foi possível carregar os cargos deste servidor — nomes de cargos de recompensa podem aparecer como IDs brutos. Atualize para tentar novamente.",
        "noRewardsConfigured": "Nenhuma recompensa configurada",
        "levelLabel": "Nível",
        "roleIdLabel": "ID do Cargo",
        "addReward": "Adicionar Recompensa",
        "adding": "Adicionando...",
        "levelSettingsSaved": "Configurações de nível salvas",
        "failedToSaveSettings": "Falha ao salvar as configurações",
        "rewardAdded": "Recompensa adicionada para o nível {{level}}",
        "failedToAddReward": "Falha ao adicionar recompensa",
        "rewardRemoved": "Recompensa removida",
        "failedToRemoveReward": "Falha ao remover recompensa",
        "levelPlaceholder": "por ex. 5",
        "roleIdPlaceholder": "ID do Cargo",
        "selectRole": "Selecione um cargo",
        "deletedRole": "Cargo excluído ({{id}})",
        "failedToLoadSettings": "Falha ao carregar as configurações de nível"
    },
    "lyrics": {
        "noServerSelected": "Nenhum Servidor Selecionado",
        "selectServerToSearch": "Selecione um servidor para pesquisar letras",
        "lyricsSearch": "Busca de Letras",
        "songTitle": "Título da Música",
        "required": "*",
        "enterSongTitle": "Digite o título da música",
        "artist": "Artista (opcional)",
        "enterArtistName": "Digite o nome do artista",
        "search": "Buscar",
        "searching": "Buscando...",
        "failedToFetchLyrics": "Falha ao buscar letras. Tente novamente.",
        "noLyricsFound": "Nenhuma letra encontrada",
        "noLyricsFoundDescription": "Tente um título diferente ou verifique a ortografia.",
        "findLyricsTitle": "Encontre a letra de qualquer música",
        "searchForLyrics": "Pesquise por letras inserindo um título de música"
    },
    "moderation": {
        "noServerSelected": "Nenhum Servidor Selecionado",
        "selectServerToViewCases": "Selecione um servidor para visualizar casos de moderação",
        "moderationCases": "Casos de Moderação",
        "manageWarningsAndBans": "Gerenciar avisos, mutes, kicks e bans",
        "totalCases": "Total de Casos",
        "activeCases": "Casos Ativos",
        "warnings": "Avisos",
        "bans": "Bans",
        "searchByUserModeratorOrReason": "Pesquisar por usuário, moderador ou motivo...",
        "allTypes": "Todos os tipos",
        "mutes": "Mutes",
        "kicks": "Kicks",
        "unbans": "Desbans",
        "unmutes": "Desmutes",
        "tableHeaderCase": "#",
        "tableHeaderUser": "Usuário",
        "tableHeaderModerator": "Moderador",
        "tableHeaderType": "Tipo",
        "tableHeaderStatus": "Status",
        "tableHeaderDate": "Data",
        "noCasesFound": "Nenhum caso encontrado",
        "tryAdjustingFilters": "Tente ajustar seus filtros",
        "moderationCasesWillAppearHere": "Os casos de moderação aparecerão aqui",
        "showingToOf": "Exibindo {{from}} a {{to}} de {{total}}",
        "caseDetailTitle": "Caso #{{number}}",
        "caseUser": "Usuário",
        "caseModerator": "Moderador",
        "caseAction": "Ação",
        "caseDate": "Data",
        "caseReason": "Motivo",
        "caseDuration": "Duração",
        "durationMinutes": "Duração: {{minutes}} minutos",
        "noReasonProvided": "Nenhum motivo fornecido",
        "active": "Ativo",
        "expired": "Expirado",
        "appealed": "Apelado",
        "deactivateCase": "Desativar Caso",
        "deactivating": "Desativando...",
        "caseDeactivated": "Caso desativado",
        "failedToDeactivateCase": "Falha ao desativar caso",
        "settingsTitle": "Configurações de moderação",
        "settingsLogChannel": "Canal de logs",
        "settingsMuteRole": "Cargo de silenciado",
        "settingsModRoles": "Cargos de moderador",
        "settingsMaxWarnings": "Avisos antes da ação",
        "settingsDmOnAction": "Enviar mensagem ao membro moderado",
        "settingsNone": "Nenhum",
        "settingsSave": "Salvar configurações",
        "settingsSaving": "Salvando...",
        "settingsSaved": "Configurações salvas",
        "settingsLoadFailed": "Falha ao carregar configurações",
        "settingsSaveFailed": "Falha ao salvar configurações",
        "settingsChannelsFailed": "Falha ao carregar canais",
        "settingsRolesFailed": "Falha ao carregar cargos",
        "settingsRetry": "Tentar novamente",
        "settingsModRolesLimit": "No máximo {{max}} cargos de moderador",
        "justNow": "Agora mesmo",
        "minutesAgo": "há {{minutes}}m",
        "hoursAgo": "há {{hours}}h",
        "daysAgo": "há {{days}}d"
    },
    "music": {
        "noServerSelected": "Nenhum Servidor Selecionado",
        "selectServerToControlMusic": "Selecione um servidor para controlar a reprodução de música",
        "musicPlayer": "Reprodutor de Música",
        "connectedToVoiceChannel": "Conectado a {{channel}}",
        "notConnectedToVoiceChannel": "Não conectado a um canal de voz",
        "connected": "Ao Vivo",
        "reconnecting": "Reconectando",
        "connectedToLiveUpdates": "Conectado às atualizações ao vivo",
        "reconnectingToLiveUpdates": "Reconectando às atualizações ao vivo",
        "nowPlaying": "Tocando Agora",
        "unknown": "Desconhecido",
        "nothingPlaying": "Nada tocando",
        "searchOrImportToGetStarted": "Comece a tocar pelo Discord com /play, ou pesquise e importe abaixo.",
        "searchDescription": "Pesquise uma música ou cole um link",
        "importDescription": "Importe uma playlist colando um link",
        "queue": "Fila",
        "volume": "Volume",
        "shuffle": "Aleatório",
        "previousTrack": "Faixa anterior",
        "play": "Reproduzir",
        "pause": "Pausar",
        "nextTrack": "Próxima faixa",
        "repeatMode": "Repetição: {{mode}}",
        "progressMayBeOutdated": "pode estar desatualizado",
        "commandInProgress": "Executando o comando…",
        "dismissError": "Dispensar",
        "playerNotConnected": "O player não está conectado",
        "viewDiscussion": "Ver discussão no Discord",
        "autoplayAcceptance": "Aceitação do autoplay",
        "timeWindow": "Janela de tempo",
        "tableHeaderSource": "Fonte",
        "tableHeaderCandidates": "Candidatos",
        "tableHeaderAccepted": "Aceitos",
        "tableHeaderRate": "Taxa",
        "autoplayLoading": "Carregando…",
        "autoplayLoadFailed": "Falha ao carregar os dados de aceitação do autoplay.",
        "noAutoplayHistoryTitle": "Ainda não há histórico de autoplay",
        "noAutoplayHistoryDescription": "Nenhuma recomendação foi registrada para este servidor nos últimos {{days}} dias.",
        "autoplayOverallSummary": "{{accepted}} de {{total}} escolhas aceitas no total ({{rate}}) nos últimos {{days}} dias."
    },
    "preferredArtists": {
        "noServerSelected": "Nenhum Servidor Selecionado",
        "selectServerToManageArtists": "Selecione um servidor para gerenciar artistas preferidos",
        "musicPersonalization": "Personalização de música",
        "musicalTaste": "Gosto Musical",
        "chooseArtistsDescription": "Escolha artistas para guiar as recomendações de autoplay. Quando várias pessoas estão em um canal de voz, Lucky mistura as preferências de todos.",
        "discoverTab": "Descobrir",
        "preferredTab": "Preferidos",
        "blockedTab": "Bloqueados",
        "searchForArtist": "Pesquise um artista...",
        "searching": "Pesquisando...",
        "failedToSearchArtists": "Falha ao pesquisar artistas",
        "noArtistsFound": "Nenhum artista encontrado para \"{{query}}\"",
        "noSuggestionsAvailable": "Nenhuma sugestão disponível. Tente pesquisar artistas acima.",
        "noPreferredArtistsYet": "Ainda nenhum artista preferido",
        "addFromDiscover": "Adicione alguns da aba Descobrir.",
        "noBlockedArtists": "Nenhum artista bloqueado",
        "blockArtistsDescription": "Bloqueie artistas que não deseja que o Lucky reproduza automaticamente.",
        "preferArtist": "Preferir",
        "blockArtist": "Bloquear",
        "savePreferences": "Salvar Preferências ({{count}})",
        "saving": "Salvando...",
        "prefer": "Preferir",
        "block": "Bloquear"
    },
    "reactionRoles": {
        "title": "Título",
        "description": "Descrição",
        "export": "Exportar",
        "import": "Importar",
        "create": "Criar",
        "noMessagesTitle": "Nenhuma mensagem de cargo por reação",
        "noMessagesDescription": "Crie sua primeira mensagem de cargo por reação para deixar os membros auto-atribuírem cargos com botões.",
        "noServerSelected": "Nenhum servidor selecionado",
        "selectServerDescription": "Selecione um servidor na barra lateral para visualizar cargos por reação.",
        "createTitle": "Criar Mensagem de Cargo por Reação",
        "editTitle": "Editar Mensagem de Cargo por Reação",
        "channel": "Canal",
        "selectChannelPlaceholder": "Selecione um canal",
        "channelCannotChange": "O canal não pode ser alterado na edição",
        "titlePlaceholder": "ex. Escolha seus cargos",
        "descriptionPlaceholder": "Explique como usar os botões abaixo…",
        "imageUrlOptional": "URL da imagem (opcional)",
        "imageUrlPlaceholder": "https://exemplo.com/imagem.png",
        "uploadImageOptional": "Enviar imagem (opcional)",
        "chooseImage": "Escolher imagem",
        "roles": "Cargos",
        "addRole": "Adicionar cargo",
        "role": "Cargo",
        "selectRolePlaceholder": "Selecione um cargo",
        "roleAboveBot": "Este cargo está no mesmo nível ou acima do cargo mais alto do bot. O Discord vai recusar; suba o cargo do bot nas configurações do servidor.",
        "aboveBotSuffix": "(no nível do bot ou acima)",
        "buttonLabel": "Rótulo do botão",
        "buttonLabelPlaceholder": "Rótulo",
        "emojiOptional": "Emoji (opcional)",
        "style": "Estilo",
        "cancel": "Cancelar",
        "submit": "Criar",
        "submitUpdating": "Atualizando…",
        "submitCreating": "Criando…",
        "submitUpdate": "Atualizar",
        "selectChannelError": "Selecione um canal",
        "titleRequiredError": "O título é obrigatório",
        "descriptionRequiredError": "A descrição é obrigatória",
        "addRoleError": "Adicione pelo menos um cargo com um rótulo",
        "createFailedError": "Falha ao criar mensagem de cargo por reação",
        "updateFailedError": "Falha ao atualizar mensagem de cargo por reação",
        "deleteFailedError": "Falha ao excluir mensagem de cargo por reação.",
        "loadFailedError": "Falha ao carregamentar mensagens de cargo por reação.",
        "noMappings": "Nenhum mapeamento de cargo encontrado para esta mensagem.",
        "createRoleGroup": "Criar grupo de cargos",
        "createRoleGroupTitle": "Crie um grupo de cargos para gerenciar cargos estilizados",
        "addStyledRole": "Adicionar cargo estilizado",
        "defaultRoleGroupName": "Grupo de Cargos {{timestamp}}",
        "createRoleGroupError": "Falha ao criar o grupo de cargos."
    },
    "serverLogs": {
        "title": "Logs do Servidor",
        "subtitle": "Logs de atividade e moderação para {{name}}",
        "export": "Exportar",
        "searchAndFilter": "Pesquisar e Filtrar",
        "searchPlaceholder": "Pesquisar logs…",
        "allLevels": "Todos os níveis",
        "info": "Informação",
        "warnings": "Avisos",
        "errors": "Erros",
        "moderation": "Moderação",
        "autoMod": "Auto-moderação",
        "system": "Sistema",
        "noServerSelected": "Nenhum Servidor Selecionado",
        "selectServerDescription": "Selecione um servidor para visualizar logs",
        "noLogsFound": "Nenhum log encontrado",
        "adjustFilters": "Tente ajustar seus filtros",
        "logsWillAppear": "Os logs aparecerão aqui conforme os eventos ocorrem",
        "exportSuccess": "Logs exportados!",
        "loadError": "Falha ao carregar logs. Por favor, tente novamente.",
        "userLabel": "Usuário:",
        "channelLabel": "Canal:",
        "loggingToggle": "Registrar atividade do servidor",
        "loggingToggleDescription": "Desligado por padrão. Quando ligado, o Lucky guarda deste servidor: entradas e saídas de membros, mensagens apagadas e editadas (até 500 caracteres de texto), banimentos e desbanimentos com o motivo, e alterações de canais e cargos.",
        "loggingToggleError": "Não foi possível atualizar o registro. Tente novamente.",
        "loggingSettingsLoadError": "Não foi possível carregar a configuração de registro. Recarregue a página para tentar de novo."
    },
    "serverSettings": {
        "title": "Configurações do Servidor",
        "description": "Configuração geral para {{name}}",
        "eyebrow": "Configuração",
        "saveChanges": "Salvar Alterações",
        "viewOnlyNotice": "Você tem acesso somente leitura a estas configurações. Não é possível salvar alterações.",
        "saving": "Salvando…",
        "noServerSelected": "Nenhum Servidor Selecionado",
        "selectServerDescription": "Selecione um servidor para gerenciar configurações",
        "unableToLoadTitle": "Não foi possível carregar as configurações do servidor",
        "retryButtonLabel": "Tentar novamente",
        "reAuthenticateLink": "Re-autenticar",
        "sessionExpired": "Sessão expirada. Por favor, faça login novamente.",
        "accessDenied": "Você não tem mais acesso às configurações deste servidor.",
        "networkError": "Não foi possível alcançar a API. Verifique sua conexão e tente novamente.",
        "general": "Geral",
        "commandPrefix": "Prefixo de Comando",
        "commandPrefixPlaceholder": "!",
        "embedColor": "Cor do Embed",
        "embedColorPlaceholder": "0x5865F2",
        "language": "Idioma",
        "musicDefaults": "Padrões de Música",
        "defaultVolume": "Volume Padrão",
        "maxQueueSize": "Tamanho Máximo da Fila",
        "commandCooldown": "Cooldown de Comando (segundos)",
        "voteSkipThreshold": "Limite de Votos para Pular (%)",
        "allowPlaylists": "Permitir Playlists",
        "allowPlaylistsDescription": "Permite que membros adicionem playlists inteiras, não só faixas únicas",
        "allowSpotify": "Permitir Spotify",
        "allowSpotifyDescription": "Permite que membros adicionem faixas a partir de links do Spotify",
        "accessControl": "Controle de Acesso",
        "accessControlDescription": "Atribuir permissões de painel web baseadas em função",
        "addRuleLabel": "Adicionar Regra",
        "saveAccessControl": "Salvar Política",
        "rbacCannotManage": "Apenas o proprietário do servidor ou usuários com permissão de Administrador/Gerenciar Servidor podem gerenciar a política RBAC.",
        "noRbacRules": "Nenhuma regra RBAC configurada. Adicione uma regra para conceder acesso a módulos.",
        "noAssignableRoles": "Nenhum cargo atribuível encontrado para este servidor ainda.",
        "retryRoles": "Tentar Cargos Novamente",
        "roleSelectPlaceholder": "Cargo",
        "moduleSelectPlaceholder": "Módulo",
        "modeSelectPlaceholder": "Modo",
        "modeView": "visualizar",
        "modeManage": "gerenciar",
        "removeRuleTitle": "Remover regra",
        "settingsSaved": "Configurações do servidor salvas!",
        "settingsSaveFailed": "Falha ao salvar configurações",
        "accessControlSaved": "Política de controle de acesso salva",
        "accessControlFailed": "Falha ao salvar política de controle de acesso",
        "stillLoadingRoles": "Ainda carregando opções de cargo. Tente novamente em alguns momentos.",
        "roleOptionsNotAvailable": "As opções de cargo ainda não estão disponíveis. Tente carregar os cargos novamente.",
        "unableToLoadMessage": "Falha ao carregar as configurações do servidor."
    },
    "servers": {
        "discordAccount": "Conta Discord",
        "totalServers": "Total de Servidores",
        "serversLabel": "Servidores",
        "yourServers": "Seus Servidores",
        "serversWithBot": "{{count}} servidores — {{count2}} com Lucky instalado",
        "navServers": "Servidores",
        "navPremium": "Premium",
        "navSettings": "Configurações",
        "recentlyActive": "Ativo Recentemente",
        "allOtherServers": "Todos os Outros Servidores",
        "luckyInstalled": "Lucky instalado",
        "inviteLucky": "Convidar Lucky",
        "noServersTitle": "Nenhum servidor ainda",
        "noServersDescription": "Junte-se a um servidor Discord e Lucky aparecerá aqui."
    },
    "spotify": {
        "eyebrow": "Personalização de música",
        "title": "Spotify",
        "description": "Conecte sua conta Spotify para recomendações de reprodução automática personalizadas",
        "notConfigured": "Não Configurado",
        "notConfiguredDesc": "Integração do Spotify não está configurada. Peça ao proprietário do servidor para definir:",
        "clientIdEnv": "SPOTIFY_CLIENT_ID",
        "clientSecretEnv": "SPOTIFY_CLIENT_SECRET",
        "connected": "Conectado",
        "linkedAs": "Conectado como",
        "active": "Ativo",
        "accessExplanation": "Lucky pode acessar sua biblioteca e histórico de reprodução para fornecer recomendações de reprodução automática personalizadas.",
        "disconnect": "Desconectar",
        "connectYourAccount": "Conecte Sua Conta",
        "connectDescription": "Conecte sua conta Spotify para que Lucky aprenda suas preferências musicais e forneça recomendações de reprodução automática personalizadas.",
        "connectWithSpotify": "Conectar com Spotify",
        "smarterAutoplay": "Reprodução automática mais inteligente",
        "smarterAutoplayDesc": "Lucky aprende com sua biblioteca, faixas principais e histórico de reprodução recente.",
        "privacyControl": "Controle de privacidade",
        "privacyControlDesc": "Desconecte a qualquer momento sem afetar a reprodução do servidor.",
        "howItWorks": "Como funciona",
        "step1": "Conecte sua conta Spotify acima",
        "step2": "Lucky acessa sua biblioteca, faixas principais e histórico de reprodução recente",
        "step3": "Quando a reprodução automática está ativa, Lucky recomenda faixas similares baseado em suas preferências",
        "step4": "Sua biblioteca permanece privada e é usada apenas para recomendações",
        "failedToLoadStatus": "Falha ao carregar status do Spotify",
        "failedToUnlink": "Falha ao desconectar conta",
        "confirmDisconnect": "Desconectar sua conta Spotify?"
    },
    "trackHistory": {
        "noServerSelected": "Nenhum Servidor Selecionado",
        "selectServerToViewHistory": "Selecione um servidor para visualizar o histórico de faixas",
        "trackHistory": "Histórico de Faixas",
        "clear": "Limpar",
        "failedToLoadHistory": "Falha ao carregar histórico de faixas",
        "tracksPlayed": "Faixas Reproduzidas",
        "playTime": "Tempo de Reprodução",
        "topArtist": "Artista Principal",
        "mostPlayed": "Mais Reproduzido",
        "none": "Nenhum",
        "topTracks": "Faixas Principais",
        "topArtists": "Artistas Principais",
        "recentTracks": "Faixas Recentes",
        "showing": "Mostrando {{count}} de {{total}}",
        "noTracksPlayed": "Nenhuma faixa reproduzida ainda",
        "playMusicToSeeHistory": "Toque alguma música para ver seu histórico aqui",
        "loadMore": "Carregar Mais ({{remaining}} restantes)",
        "loading": "Carregando...",
        "clearConfirmTitle": "Limpar histórico de músicas?",
        "clearConfirmDescription": "Isso remove permanentemente o histórico e as estatísticas de músicas deste servidor. Não é possível desfazer.",
        "failedToClearHistory": "Falha ao limpar histórico",
        "playedBy": "Por <bold>{{user}}</bold>",
        "justNow": "Agora mesmo",
        "minutesAgo": "há {{minutes}} min",
        "hoursAgo": "há {{hours}} h",
        "daysAgo": "há {{days}} d"
    },
    "twitch": {
        "selectServerToManage": "Selecione um servidor para gerenciar notificações do Twitch",
        "twitchNotifications": "Notificações do Twitch",
        "notConfigured": "Não Configurado",
        "notConfiguredDesc": "A API do Twitch não está configurada neste servidor. Entre em contato com o administrador do servidor para configurar as credenciais do Twitch.",
        "noNotificationsConfigured": "Nenhuma notificação do Twitch configurada",
        "add": "Adicionar",
        "addTwitchNotification": "Adicionar Notificação do Twitch",
        "twitchUrlOrLogin": "URL ou login do Twitch",
        "twitchUrlPlaceholder": "URL ou login do Twitch (por exemplo, https://twitch.tv/luk)",
        "selectDiscordChannel": "Selecionar canal do Discord",
        "save": "Salvar",
        "cancel": "Cancelar",
        "invalidTwitchInput": "Digite uma URL ou login válido do Twitch",
        "alreadyConfigured": "Este canal do Twitch já está configurado",
        "failedToAddNotification": "Falha ao adicionar notificação",
        "failedToRemoveNotification": "Falha ao remover notificação",
        "removeAriaLabel": "Remover {{login}}",
        "removeConfirmTitle": "Remover notificação?",
        "removeConfirmDescription": "Parar de enviar alertas de {{login}} ao vivo para este servidor?",
        "remove": "Remover",
        "failedToLoadNotifications": "Falha ao carregar as notificações da Twitch",
        "failedToLoadChannels": "Falha ao carregar os canais do Discord"
    },
    "batchJobs": {
        "noServerSelected": "Nenhum Servidor Selecionado",
        "selectServerToViewJobs": "Selecione um servidor para visualizar operações em lote",
        "batchJobs": "Operações em Lote",
        "manageOperations": "Gerencie operações em massa em seu servidor",
        "jobType": "Tipo de Operação",
        "status": "Status",
        "initiated": "Iniciado Por",
        "progress": "Progresso",
        "date": "Data",
        "allStatuses": "Todos os status",
        "pending": "Pendente",
        "in_progress": "Em Andamento",
        "paused": "Pausado",
        "completed": "Concluído",
        "failed": "Falha",
        "cancelled": "Cancelado",
        "noBatchJobsFound": "Nenhuma operação encontrada",
        "tryAdjustingFilters": "Tente ajustar seus filtros",
        "batchJobsWillAppearHere": "As operações em lote aparecerão aqui",
        "showingToOf": "Mostrando {{from}} a {{to}} de {{total}}",
        "tableHeaderJob": "Operação",
        "tableHeaderType": "Tipo",
        "tableHeaderStatus": "Status",
        "tableHeaderInitiator": "Iniciado Por",
        "tableHeaderProgress": "Progresso",
        "tableHeaderDate": "Data",
        "jobDetails": "Detalhes da Operação",
        "targetInfo": "Informações de Destino",
        "items": "Itens",
        "totalItems": "Total de Itens",
        "processedItems": "Processados",
        "failedItems": "Falhados",
        "skippedItems": "Ignorados",
        "successItems": "Bem-sucedidos",
        "createdAt": "Criado",
        "startedAt": "Iniciado",
        "completedAt": "Concluído",
        "estimatedTime": "Tempo Estimado",
        "minutes": "{{count}} minutos",
        "liveProgress": "Progresso em Tempo Real",
        "refresh": "Atualizar",
        "cancel": "Cancelar",
        "cancelJob": "Cancelar Operação",
        "previousPage": "Página anterior",
        "nextPage": "Próxima página",
        "cancelJobConfirmTitle": "Cancelar esta operação?",
        "cancelJobConfirmDescription": "Os itens já processados não serão revertidos.",
        "cancelJobConfirm": "Sim, cancelar operação",
        "keepJob": "Manter operação",
        "cancelling": "Cancelando...",
        "jobCancelled": "Operação cancelada",
        "failedToCancelJob": "Falha ao cancelar operação",
        "failedToLoadJobs": "Falha ao carregar operações",
        "failedToLoadJobDetails": "Falha ao carregar detalhes da operação",
        "jobItemStatus": "Status do Item",
        "noItemsFound": "Nenhum item encontrado",
        "itemsWillAppearHere": "Os itens da operação aparecerão aqui"
    },
    "roleGroups": {
        "noServerSelected": "Nenhum servidor selecionado",
        "selectServerToView": "Selecione um servidor para gerenciar seus grupos de cargos.",
        "loadError": "Falha ao carregar grupos de cargos",
        "noGroupsYet": "Nenhum grupo de cargos ainda",
        "noGroupsHint": "Grupos de cargos são criados a partir de um painel de Cargos por reação — abra Cargos por reação, escolha um painel e clique em \"Criar grupo de cargos\".",
        "linkedPanel": "Painel",
        "rolesInGroup": "Cargos neste grupo",
        "noRolesInGroup": "Nenhum cargo neste grupo ainda — adicione um abaixo.",
        "removeRole": "Remover cargo",
        "roleRemoved": "Cargo removido do grupo",
        "removeError": "Falha ao remover cargo",
        "color": "Cor",
        "buttonStyle": "Estilo do botão",
        "hoist": "Exibir separadamente",
        "mentionable": "Mencionável",
        "defaultEmoji": "Emoji padrão",
        "save": "Salvar",
        "saving": "Salvando...",
        "saved": "Grupo de cargos atualizado",
        "saveError": "Falha ao salvar grupo de cargos",
        "addRole": "Adicionar cargo estilizado",
        "cancelAddRole": "Cancelar"
    }
}
